<template>
  <card id="gatewayProperties" no-header no-body no-footer>
    <table slot="card-table" class="table table-sm table-ellipsis mb-0">
      <tbody>
        <tr>
          <td class="text-uppercase">{{ $t('g-properties:eui') }}</td>
          <td :title="gateway.eui">{{ gateway.eui }}</td>
        </tr>
        <tr>
          <td class="text-uppercase">{{ $t('g-properties:name') }}</td>
          <td>{{ gateway.name }}</td>
        </tr>
        <tr>
          <td class="text-uppercase">{{ $t('g-properties:fleet') }}</td>
          <td v-if="gateway.fleet">{{ gateway.fleet.name }}</td>
          <td v-else class="text-muted">{{ $t('g-properties:unknown') | capitalize }}</td>
        </tr>
        <tr>
          <td class="text-uppercase">{{ $t('g-properties:brand') }}</td>
          <td v-if="gateway.brand" :title="gateway.brand.name">{{ gateway.brand.name | gatewayBrand }}</td>
          <td v-else class="text-muted">{{ $t('g-properties:unknown') | capitalize }}</td>
        </tr>
        <tr>
          <td class="text-uppercase">{{ $t('g-properties:description') }}</td>
          <td :title="gateway.description">{{ gateway.description }}</td>
        </tr>
        <tr>
          <td class="text-uppercase">{{ $t('g-properties:region') }}</td>
          <td>{{ gateway.region }}<span v-if="gateway.country"> ({{ gateway.country }})</span></td>
        </tr>
        <tr>
          <td class="text-uppercase">{{ $t('g-properties:visibility') }}</td>
          <td>{{ $t('g-properties:visibilities.' + gateway.visibility) | capitalize }}</td>
        </tr>
        <tr>
          <td class="text-uppercase">{{ $t('g-properties:ipPort') }}</td>
          <td>{{ gateway.ip }}:{{ gateway.port }}</td>
        </tr>
        <tr>
          <td class="text-uppercase">{{ $t('g-properties:status') }}</td>
          <td>
            <span v-if="gateway.connection === true" class="text-success">{{ $t('g-properties:connected') | capitalize }}</span>
            <span v-else-if="gateway.connection === false" class="text-danger">{{ $t('g-properties:disconnected') | capitalize }}</span>
            <span v-else class="text-muted">{{ $t('g-properties:neverConnected') | capitalize }}</span>
            <span v-if="gateway.bearer" class="ml-1">({{ $t('g-properties:' + gateway.bearer) }})</span>
          </td>
        </tr>
        <tr>
          <td class="text-uppercase">{{ $t('g-properties:door') }}</td>
          <td>
            <span v-if="!$store.getters.gatewayFeature(gateway, 'door')" class="text-muted">{{ $t('g-properties:notApplicable') | capitalize }}</span>
            <span v-else-if="gateway.door === 'CLOSED'" class="text-success">{{ $t('g-properties:closed') | capitalize }}</span>
            <span v-else-if="gateway.door === 'OPEN'" class="text-danger">{{ $t('g-properties:open') | capitalize }}</span>
            <span v-else-if="gateway.door === 'NOT_APPLICABLE'" class="text-muted">{{ $t('g-properties:notApplicable') | capitalize }}</span>
            <span v-else class="text-muted">{{ $t('g-properties:unknown') | capitalize }}</span>
          </td>
        </tr>
        <tr>
          <td class="text-uppercase">{{ $t('g-properties:gps') }}</td>
          <td>
            <span v-if="!$store.getters.gatewayFeature(gateway, 'gps')" class="text-muted">{{ $t('g-properties:notApplicable') | capitalize }}</span>
            <span v-else-if="gateway.gps === 'LOCKED'" class="text-success">{{ $t('g-properties:locked') | capitalize }}</span>
            <span v-else-if="gateway.gps === 'UNLOCKED'" class="text-danger">{{ $t('g-properties:unlocked') | capitalize }}</span>
            <span v-else-if="gateway.gps === 'NOT_APPLICABLE'" class="text-muted">{{ $t('g-properties:notApplicable') | capitalize }}</span>
            <span v-else class="text-muted">{{ $t('g-properties:unknown') | capitalize }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </card>
</template>

<script>

export default {
  props: {
    gateway: {
      type: Object,
      required: true
    }
  }

}
</script>
